import { render } from "./UploadMenu.vue?vue&type=template&id=273065bd&scoped=true"
import script from "./UploadMenu.vue?vue&type=script&lang=js"
export * from "./UploadMenu.vue?vue&type=script&lang=js"

import "./UploadMenu.vue?vue&type=style&index=0&id=273065bd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-273065bd"]])

export default __exports__